import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "burger",
  "use": "burger-usage",
  "viewBox": "0 0 30 30",
  "content": "<symbol viewBox=\"0 0 30 30\" fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" id=\"burger\">\n<path d=\"M5 22H25M5 14.5H15H25M5 7H25\" stroke=\"currentColor\" stroke-width=\"3\" stroke-linecap=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol